import TruckInfo from "./TruckInfo";

export default TruckInfo;
